import { Routes, Route } from "react-router-dom"
import { GuestLayout } from "./components/GuestLayout"
import { AuthLayout } from "./components/AuthLayout"
import { Login } from "./pages/Login"
import { PasswordDimenticata } from "./pages/PasswordDimenticata"
import { ResetPassword } from "./pages/ResetPassword"
import { AttivazioneAccount } from "./pages/AttivazioneAccount"
import { MagikUI } from "@inmagik/magik-ui"
import UtenteCreate from "./pages/Utenti/UtenteCreate"
import UtenteUpdate from "./pages/Utenti/UtenteUpdate"
import Utenti from "./pages/Utenti/Utenti"
import Profilo from "./pages/Profilo/Profilo"
import { Home } from "./pages/Home"
import Texts from "./pages/Texts/Texts"
import TextCreate from "./pages/Texts/TextCreate"
import TextUpdate from "./pages/Texts/TextUpdate"
import GroupOfResearchCreate from "./pages/GroupOfResearches/GroupOfResearchCreate"
import GroupsOfResearches from "./pages/GroupOfResearches/GroupOfResearches"
import GroupOfResearchUpdate from "./pages/GroupOfResearches/GroupOfResearchUpdate"
import Themes from "./pages/Themes/Themes"
import ThemeCreate from "./pages/Themes/ThemeCreate"
import ThemeUpdate from "./pages/Themes/ThemeUpdate"
import NamedEntities from "./pages/NamedEntities/NamedEntities"
import NamedEntityCreate from "./pages/NamedEntities/NamedEntityCreate"
import NamedEntityUpdate from "./pages/NamedEntities/NamedEntityUpdate"
import Media from "./pages/Media/Media"
import MediaCreate from "./pages/Media/MediaCreate"
import MediaUpdate from "./pages/Media/MediaUpdate"
import Paths from "./pages/Paths/Paths"
import PathCreate from "./pages/Paths/PathCreate"
import PathUpdate from "./pages/Paths/PathUpdate"

export function Navigation() {
  return (
    <MagikUI>
      <Routes>
        <Route path="/" element={<AuthLayout redirect_to="/login" />}>
          <Route index element={<Home />}></Route>
          <Route path="/utenti/utenti" element={<Utenti />}></Route>
          <Route path="/utenti/utenti/new" element={<UtenteCreate />}></Route>
          <Route path="/utenti/utenti/:id" element={<UtenteUpdate />}></Route>
          <Route path="/text-contents/text-contents" element={<Texts />}></Route>
          <Route path="/text-contents/text-contents/new" element={<TextCreate />}></Route>
          <Route path="/text-contents/text-contents/:id" element={<TextUpdate />}></Route>
          <Route path="/group-of-researches/group-of-researches" element={<GroupsOfResearches />}></Route>
          <Route path="/group-of-researches/group-of-researches/new" element={<GroupOfResearchCreate />}></Route>
          <Route path="/group-of-researches/group-of-researches/:id" element={<GroupOfResearchUpdate />}></Route>
          <Route path="/themes/themes" element={<Themes />}></Route>
          <Route path="/themes/themes/new" element={<ThemeCreate />}></Route>
          <Route path="/themes/themes/:id" element={<ThemeUpdate />}></Route>
          <Route path="/named-entities/named-entities" element={<NamedEntities />}></Route>
          <Route path="/named-entities/named-entities/new" element={<NamedEntityCreate />}></Route>
          <Route path="/named-entities/named-entities/:id" element={<NamedEntityUpdate />}></Route>
          <Route path="/media/media" element={<Media />}></Route>
          <Route path="/media/media/new" element={<MediaCreate />}></Route>
          <Route path="/media/media/:id" element={<MediaUpdate />}></Route>
          <Route path="/paths/paths" element={<Paths />}></Route>
          <Route path="/paths/paths/new" element={<PathCreate />}></Route>
          <Route path="/paths/paths/:id/*" element={<PathUpdate />}></Route>
          <Route path="/profilo" element={<Profilo />}></Route>
        </Route>
        <Route path="/login" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<Login />}></Route>
        </Route>
        <Route path="/password-dimenticata" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<PasswordDimenticata />}></Route>
        </Route>
        <Route path="/reset-password" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<ResetPassword />}></Route>
        </Route>
        <Route path="/attivazione-account" element={<GuestLayout redirect_to="/" />}>
          <Route index element={<AttivazioneAccount />}></Route>
        </Route>
      </Routes>
    </MagikUI>
  )
}
